/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  TriggerAnalysisRequestBody,
  TriggerAnalysisRequestBody$Outbound,
  TriggerAnalysisRequestBody$outboundSchema,
} from "../components/triggeranalysisrequestbody.js";

export type TriggerChatAnalysisSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type TriggerChatAnalysisRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  triggerAnalysisRequestBody: TriggerAnalysisRequestBody;
};

/** @internal */
export type TriggerChatAnalysisSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const TriggerChatAnalysisSecurity$outboundSchema: z.ZodMiniType<
  TriggerChatAnalysisSecurity$Outbound,
  TriggerChatAnalysisSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function triggerChatAnalysisSecurityToJSON(
  triggerChatAnalysisSecurity: TriggerChatAnalysisSecurity,
): string {
  return JSON.stringify(
    TriggerChatAnalysisSecurity$outboundSchema.parse(
      triggerChatAnalysisSecurity,
    ),
  );
}

/** @internal */
export type TriggerChatAnalysisRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  TriggerAnalysisRequestBody: TriggerAnalysisRequestBody$Outbound;
};

/** @internal */
export const TriggerChatAnalysisRequest$outboundSchema: z.ZodMiniType<
  TriggerChatAnalysisRequest$Outbound,
  TriggerChatAnalysisRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    triggerAnalysisRequestBody: TriggerAnalysisRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      triggerAnalysisRequestBody: "TriggerAnalysisRequestBody",
    });
  }),
);

export function triggerChatAnalysisRequestToJSON(
  triggerChatAnalysisRequest: TriggerChatAnalysisRequest,
): string {
  return JSON.stringify(
    TriggerChatAnalysisRequest$outboundSchema.parse(triggerChatAnalysisRequest),
  );
}
